import { TAP_LIMIT } from '../../../constants/AppConstants';
import Item, { SIZE_GROUND } from './Item';

export default class TentRolled extends Item {
  constructor({ game, location, data }) {
    super({ game, location, data });

    if (this.game.deviceMetric.platform.type === 'desktop') {
      // desktop
      this.events.onInputUp.add(this.handleInputUp, this);
    }
  }

  handleInputUp() {
    this.location.stopDragItem(this);
    this.drag = false;
    this.updateBounds();

    this.setScale(SIZE_GROUND);

    // check if it was moved
    const dx = this.pointer.x - this.startPos.x;
    const dy = this.pointer.y - this.startPos.y;
    const dist = Math.sqrt(dx * dx + dy * dy);

    this.pointer = null;

    if (dist < TAP_LIMIT) {
      this.handleTap();
    } else {
      // drop item
      this.onDrop.dispatch(this);
    }
  }
}
